<template>
    <div class="np-form-final">
        <div class="np-form-final__user-info">
            <new-payment-form-final-field
                label="ФИО плательщика"
                :value="fullName(form.userInfo.lastName,
                                form.userInfo.firstName,
                                form.userInfo.patronymic)"
            />
            <new-payment-form-final-field
                label="Дата рождения плательщика"
                :value="form.userInfo.birthday"
            />
            <new-payment-form-final-field
                v-if="formType !== 'hospitals'"
                label="Плательщик является пациентом"
                :value="form.userInfo.confirmation ? 'Да' : 'Нет'"
            />
            <new-payment-form-final-field
                v-else-if="formType === 'hospitals'"
                label="Оплата за другого пациента"
                :value="form.userInfo.paymentForAnotherPatient ? 'Да' : 'Нет'"
            />
            <new-payment-form-final-field
                v-if="form.userInfo.paymentForAnotherPatient || !form.userInfo.confirmation"
                label="ФИО пациента"
                :value="fullName(form.userInfo.patient.lastName,
                                form.userInfo.patient.firstName,
                                form.userInfo.patient.patronymic)"
            />
            <new-payment-form-final-field
                label="Email"
                :value="form.contactsInfo.email"
            />
            <new-payment-form-final-field
                label="Телефон"
                :value="form.contactsInfo.phone"
            />
        </div>
        <div class="np-form__type-description __last-step">
            <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M22 2.5H2L2 5.87498H22V2.5ZM2 15.5L2 7.87498H22V15.5H2ZM2 0.5C0.895431 0.5 0 1.39543 0 2.5V15.5C0 16.6046 0.89543 17.5 2 17.5H22C23.1046 17.5 24 16.6046 24 15.5V2.5C24 1.39543 23.1046 0.5 22 0.5H2ZM5.45459 11.1875C4.90231 11.1875 4.45459 11.6352 4.45459 12.1875C4.45459 12.7398 4.90231 13.1875 5.45459 13.1875H8.13058C8.68286 13.1875 9.13058 12.7398 9.13058 12.1875C9.13058 11.6352 8.68286 11.1875 8.13058 11.1875H5.45459Z" fill="#00ABAA"/>
            </svg>
            <div class="np-form__type-description-text">
                Оплата банковской картой
            </div>
        </div>
        <div class="np-form-final__payment-info">
            <div class="np-form-final__payment-info-top">
                <div class="np-form-final__payment-info-top-price">
                    <span class="pay-info-price">
                        {{ formattedSum(this.form.contactsInfo.paymentAmount) }} руб.
                    </span>
                    <span class="pay-info-description">Сумма платежа</span>
                </div>
                <button 
                    class="np-form-final__payment-info-top-button"
                    :class="{__disabled : !isAgree}"
                    @click="$emit('submit-form')"
                >
                    Перейти к оплате
                </button>
            </div>
            <div v-if="error" class="np-form-final__error">
                {{ error }}
            </div>
            <div class="np-form-final__agreement-check-box">
                <NewPaymentFormCheckbox
                    @change="toggleIsAgree"
                    v-model="isAgree"
                    :state="isAgree"
                    :key="`isAgree: ${isAgree.toString()}`"
                    :name="'isAgree'"
                    :hasUrl="true"
                    :text="agreemrntText"
                />
            </div>
            <!-- <div class="np-form-final__payment-info-description">
                * Нажимая кнопку «Перейти к оплате», вы соглашаетесь с обработкой своих персональных данных АО «Группа компаний «МЕДСИ»
            </div> -->
        </div>
    </div>
</template>

<script>
import NewPaymentFormFinalField from "@/components/new-payment-form/NewPaymentFormFinalField";
import NewPaymentFormCheckbox from './NewPaymentFormCheckbox.vue';

export default {
    name: "NewPaymentFormFinal",
    components: {
        NewPaymentFormFinalField,
        NewPaymentFormCheckbox
    },
    props: {
        form: {
            type: Object,
            default: {}
        },
        formType: {
            default: 'default'
        },
        error: {}
    },
    data() {
        return {
            isAgree: false,
            agreemrntText: '<span>Я согласен с условиями <a href="/document_politics.php" target="_blank">Политики обработки персональных данных</a> и даю <a href="/document.php?element=103802151" target="_blank">Согласие на обработку моих персональных данных</a></span>'
        }
    },
    methods: {
        fullName(lastName, firstName, patronymic) {
            return lastName + ' ' + firstName + ' ' + patronymic
        },
        formattedSum(sum) {
            return new Intl.NumberFormat('ru-RU').format(sum)
        },
        toggleIsAgree() {
            this.isAgree = !this.isAgree;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mixins-and-vars';

$parent: '.np-form-final';

#{$parent} {
    animation: ezTransformOpacity .2s linear;

    &__user-info {
        display: flex;
        flex-direction: column;
        padding: 20px;
        background: #FAF9F8;
        border-radius: 16px;
    }

    &__error {
        margin-top: 20px;
        font-size: 14px;
        color: #f11d1d;
    }

    &__payment-info {
        display: flex;
        flex-direction: column;
        margin-top: 12px;
        padding: 25px 28px 20px 20px;
        background: #FAF9F8;
        border-radius: 16px;

        &-top {
            display: flex;
            justify-content: space-between;

            @include mobile {
                flex-direction: column;
            }

            &-button {
                display: flex;
                align-items: center;
                padding: 15px 48px;
                margin: auto 0;
                background: #FFDA00;
                border-radius: 7px;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                border: none;
                cursor: pointer;
                transition: $transition;

                @include mobile {
                    flex-direction: column;
                    margin: 15px auto 0 0;
                }

                &:hover {
                    background: #ffec77;
                }
            }
            &-button.__disabled {
                pointer-events: none;
                opacity: 0.4;
            }

            &-price {
                display: flex;
                flex-direction: column;
                margin-left: 8px;

                & .pay-info-price {
                    font-weight: 700;
                    font-size: 24px;
                    display: flex;
                    align-items: center;
                    color: #333333;
                }
                & .pay-info-description {
                    font-size: 14px;
                    color: #333333;
                }
            }
        }

        &-description {
            margin-top: 25px;
            font-weight: 400;
            font-size: 12px;
            line-height: 160%;
            color: #7D7987;
        }

        &-links {
            display: flex;
            flex-direction: column;
            margin-top: 12px;

            &-item {
                margin-right: auto;
                line-height: 22px;
                font-weight: 400;
                font-size: 12px;
                text-decoration: underline;
                color: #00b2ac;
            }
        }
    }
    &__agreement-check-box {
        margin-top: 20px;
    }
}

</style>